export const addVolumesFaturados = (data, faturamento, group, funnelGroups) => {
  let groupId = group?.funnelGroupId;
  const isBasicas = faturamento.nomeGrupoMaterial === "Basicas" || faturamento.nomeGrupoMaterial === "Básicas";
  
  if (isBasicas) {
    const basicas = faturamento.codigoUnidadeMedida === "TO"
      ? ["basicas granel", "básicas granel"]
      : ["basicas ensacado", "basicas ensacados", "básicas ensacado", "básicas ensacados"];
    groupId = Object.values(funnelGroups).find(item => basicas.includes(item.nome?.toLowerCase()))?.id;
  }

  if (groupId == null) return;

  const cliente = data[faturamento.clienteId] ??= {};
  const key = `id-${groupId}`;
  const volume = Number(Math.round(faturamento.volume).toFixed(2)) ?? 0;
  cliente[key] = (cliente[key] ?? 0) + volume;
};
